import { createFileRoute } from "@tanstack/react-router";
import { KeysSettings } from "../../../../features/settings/keys/keys-settings";

export const Route = createFileRoute("/w/$slug/settings/keys")({ component: KeysSettings });
